import { FC, ReactNode } from "react";
import { Empty, EmptyProps } from "antd";
import { useTranslation } from "react-i18next";

const NoData: FC<{ children?: ReactNode } & EmptyProps> = ({ children, ...props }) => {
  const { t } = useTranslation();
  return (
    <div className="flex w-full items-center justify-center py-10">
      <Empty image={Empty.PRESENTED_IMAGE_DEFAULT} description={t("Common.noDataFound")} {...props}>
        {children}
      </Empty>
    </div>
  );
};

export default NoData;
